import { GoogleMap } from '@react-google-maps/api';
import LocationMarkers, {
  OwnProps as LocationMarkersProps
} from './LocationMarkers';

export default function CustomGoogleMap(props: LocationMarkersProps) {
  const { center, isVisible, onMapLoad, onZoomChanged, zoom, zoomStyles } =
    props;

  return isVisible ? (
    <GoogleMap
      id="example-map"
      options={{
        fullscreenControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        zoomControl: true,
        styles: zoomStyles
      }}
      mapContainerClassName="mapContainer"
      zoom={zoom}
      onZoomChanged={onZoomChanged}
      center={center}
      onLoad={onMapLoad}
    >
      <LocationMarkers {...props} />
    </GoogleMap>
  ) : null;
}
